import React, { useEffect, useState } from "react";
import Hero from "./Hero";
import PostContent from "./PostContent";
import RecentBlog from "./RecentBlog";
import Footer from "../../CommonComponent/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAllBlogsAction,
  getSingleBlog,
} from "../../../redux/actions/blogsList";
import { scroll } from "../../../utils/scrollTop";
import { metaData } from "../../../utils/metaData";
import PageNotFound from "../../PageNotFound/PageNotFound";
import Loader from "../../../utils/Loader";
import { trackPageVisit } from "../../../utils/pageTracker";
import Footer2 from "../../CommonComponent/Footer2";

const Blog = () => {
  const blog = useSelector((state) => state?.allblogs?.blogsList);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isAfterLoading, setIsAfterLoading] = useState(false)

  useEffect(() => {
    dispatch(getSingleBlog(id));
    dispatch(getAllBlogsAction());
  }, [dispatch, id]);

  const singlepostdata = useSelector((state) => state?.allblogs?.singleBlogs);
  const postcontent = singlepostdata?.post_content
  const loading = useSelector((state) => state?.allblogs?.isSinglBlog);
  const error = useSelector((state) => state?.allblogs?.error);

  useEffect(() => {
    scroll();
    trackPageVisit();
    document.body.classList.add("blog-page");
    return () => {
      document.body.classList.remove("blog-page");
    };
  }, [window.location.href]);
  
  useEffect(() => {
    if (!loading) {
      setIsAfterLoading(true);
    }
  }, [loading]);

  if (loading) {
    return (
      <Loader />
    );
  }
  if (isAfterLoading && (error || !singlepostdata || (Array.isArray(singlepostdata) && singlepostdata.length === 0))) {
    return <PageNotFound />;
  } else metaData(id);
  return (
    <>
      <Hero data={singlepostdata} />
      <PostContent data={postcontent} singlepostdata={singlepostdata} />
      <RecentBlog blog={blog} />
      <Footer2 />

      {/* <Footer /> */}
    </>
  );
};

export default Blog;